import React, { useState } from 'react';
import { Menu, X, Video, Globe } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="flex justify-between h-16" data-id="element-104">
          <div className="flex items-center" data-id="element-105">
            <div className="flex-shrink-0 flex items-center" data-id="element-106">
              <Video className="h-8 w-8 text-indigo-600" data-id="element-107" />
              <span className="ml-2 text-xl font-bold text-gray-900" data-id="element-108">
                VideoScribe
              </span>
            </div>
            <nav className="hidden md:ml-10 md:flex md:space-x-8" data-id="element-109">
              <a href="#features" className="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium" data-id="element-110">
                Features
              </a>
              <a href="#how-it-works" className="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium" data-id="element-111">
                How It Works
              </a>
              <a href="#pricing" className="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium" data-id="element-112">
                Pricing
              </a>
            </nav>
          </div>
          <div className="hidden md:flex items-center" data-id="element-113">
            <a href="#" className="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium" data-id="element-114">
              Log in
            </a>
            <a href="#" className="ml-8 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-115">
              Get started
            </a>
          </div>
          <div className="flex items-center md:hidden" data-id="element-116">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-117">
              <span className="sr-only" data-id="element-118">Open main menu</span>
              {mobileMenuOpen ? <X className="block h-6 w-6" data-id="element-119" /> : <Menu className="block h-6 w-6" data-id="element-120" />}
            </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && <div className="md:hidden" data-id="element-121">
          <div className="pt-2 pb-3 space-y-1" data-id="element-122">
            <a href="#features" className="block pl-3 pr-4 py-2 border-l-4 border-indigo-500 text-base font-medium text-indigo-700 bg-indigo-50" onClick={() => setMobileMenuOpen(false)} data-id="element-123">
              Features
            </a>
            <a href="#how-it-works" className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800" onClick={() => setMobileMenuOpen(false)} data-id="element-124">
              How It Works
            </a>
            <a href="#pricing" className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800" onClick={() => setMobileMenuOpen(false)} data-id="element-125">
              Pricing
            </a>
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-126">
            <div className="flex items-center px-4" data-id="element-127">
              <div className="flex-shrink-0" data-id="element-128">
                <a href="#" className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100" data-id="element-129">
                  Log in
                </a>
                <a href="#" className="block px-4 py-2 text-base font-medium text-indigo-600 hover:text-indigo-800 hover:bg-gray-100" data-id="element-130">
                  Get started
                </a>
              </div>
            </div>
          </div>
        </div>}
    </header>;
}